import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import MembershipAddLayer from "../../components/MembershipPlan/MemberShipCreation";


const AddMembership = () => {
  return (
    <>


        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Membership  </h5><Breadcrumb title="Add Membership" /></div>


        {/* AddUserLayer */}
        <MembershipAddLayer />


    </>
  );
};

export default AddMembership;